import cx from 'classnames';
import { Location } from 'history';
import range from 'lodash-es/range';
import { BLOGS_ADD_NEW_COMMENT_PLACEHOLDER, SEND_COMMENT_FORUM } from 'mk/autogenerated/translations/CommentList.21661c45e4bc5bed89e3ccf1e157e9e1'
import assetUrl from 'mk/common/assetUrl';
import { BlogPostCommentCreateFormFactory } from 'mk2/apps/blogs/components/BlogPostCommentCreateForm';
import Comment, { CommentPlaceholder } from 'mk2/apps/blogs/components/Comment';
import { MessageFormFactory } from 'mk2/apps/blogs/components/MessageForm';
import { COMMENT_TEXTAREA } from 'mk2/apps/blogs/helpers';
import { ArticleEntity, BlogPostEntity, CommentEntity } from 'mk2/apps/blogs/schemas';
import { CommentFormData } from 'mk2/apps/forum/components/CommentCreateEditForm';
import Img from 'mk2/components/Img';
import Complaint from 'mk2/containers/Complaint/Complaint';
import { ComplaintTargetType } from 'mk2/containers/Complaint/Complaint.schemas';
import Deletion from 'mk2/containers/Deletion/Deletion';
import { DeletionTargetType } from 'mk2/containers/Deletion/Deletion.schemas';
import { isSuccess, LoadingState } from 'mk2/reducers/loadingState';
import { UserEntity } from 'mk2/schemas';
import React from 'react';
import styles from './CommentList.mscss';

interface OwnProps {
    comments: CommentEntity[];
    requestUser: UserEntity;
    requestUserPermissions: string[];
    isIOS: boolean;
    mobile: boolean;
    moderators: UserEntity[];
    canAdd: boolean; // has add new comment form
    hasBlueToolbar?: boolean;
    showFakeTextareaIfCantAdd: boolean;
    post?: ArticleEntity | BlogPostEntity;
    postId: number;
    postKey: string;
    highlightTriggeredId: number;
    highlightStartedId: number;
    inGroups?: boolean;
    initialValues: CommentFormData;
    inPrivateGroup?: boolean;
    loadingState: LoadingState;
    complaintsOpened: boolean[];

    location: Location;
    count?: number;

    onDidHighlight?(commentId: number);
    onSetTextareaRef?(ref: any);
    onLike(commentId: number);
    onCreate(commentFd: CommentFormData);
    onReply(username: string);
    onDelete(commentId: number);
    onReport(entityType: ComplaintTargetType, commentId: number);
    onSendHeart();
    onToggleMenuMore?(commentId: number);
    onBlur?();
    onFocus?();
    onAddCommentUnauthenticated?();
    onStoreEvent(name: string, props: any);
}

export default class CommentList extends React.PureComponent<OwnProps> {

    public static defaultProps: Partial<OwnProps> = {
        count: 3,
    };

    private BlogPostCommentCreateForm = BlogPostCommentCreateFormFactory(COMMENT_TEXTAREA(this.props.postKey));
    private MessageForm = MessageFormFactory(COMMENT_TEXTAREA(this.props.postKey));
    private messageFormTextarea: HTMLTextAreaElement;

    public componentWillUpdate(nextProps: OwnProps) {
        if (nextProps.postKey !== this.props.postKey) {
            this.BlogPostCommentCreateForm = BlogPostCommentCreateFormFactory(COMMENT_TEXTAREA(nextProps.postKey));
            this.MessageForm = MessageFormFactory(COMMENT_TEXTAREA(nextProps.postKey));
        }
    }

    public render() {
        const {
            comments, canAdd, showFakeTextareaIfCantAdd, requestUser, requestUserPermissions, onCreate, inGroups,
            initialValues, isIOS, count, highlightStartedId, highlightTriggeredId, mobile, postKey, loadingState,
            complaintsOpened, onDidHighlight, onSendHeart, location, moderators, onBlur, onDelete, onFocus, onReport,
            onToggleMenuMore, hasBlueToolbar, post,
        } = this.props;

        const BlogPostCommentCreateForm = this.BlogPostCommentCreateForm;
        const MessageForm = this.MessageForm;

        return (
            <div className={styles.CommentList}>
                <ul
                    className={cx(
                        styles.CommentList__list,
                        inGroups ? styles['CommentList__list--inGroups'] : styles['CommentList__list--inBlogs'],
                    )}
                >
                    { isSuccess(loadingState) || comments.length ?
                        (comments.map((comment, index) => (
                            <div
                                key={comment.id}
                                className={cx(
                                    complaintsOpened[index] && styles['CommentList__list--reporting'],
                                    complaintsOpened[index] && inGroups && styles['CommentList__list--reporting--inGroups'],
                                )}
                            >
                                <Complaint
                                    className={styles.CommentList__list__complaint}
                                    entity={ComplaintTargetType.PhotoblogComment}
                                    id={comment.id}
                                    inForum={false}
                                    inGroups={inGroups}
                                />

                                <Deletion
                                    className={styles.CommentList__list__complaint}
                                    entity={DeletionTargetType.PhotoblogComment}
                                    id={comment.id}
                                />

                                <Comment
                                    key={comment.id}
                                    inForum={false}
                                    inGroups={inGroups}
                                    comment={comment}
                                    highlightTriggered={comment.id === highlightTriggeredId}
                                    highlightStarted={comment.id === highlightStartedId}
                                    isMobile={mobile}
                                    requestUser={requestUser}
                                    requestUserPermissions={requestUserPermissions}
                                    hasBodyHiddenText={false}
                                    hasBodyDeletedStatus={false}
                                    hasFooterLike
                                    hasFooterReply
                                    hasMenu
                                    hasMenuReport={inGroups ? true : false}
                                    hasMenuEdit={false}
                                    hasMenuDelete={inGroups ? true : false}
                                    moderators={moderators}
                                    onDidHighlight={onDidHighlight}
                                    onReply={this.onReply}
                                    onDelete={onDelete}
                                    onReport={onReport}
                                    onSendHeart={onSendHeart}
                                    onToggleMenuMore={onToggleMenuMore}
                                    hasMenuMoveUp={false}
                                    location={location}
                                    post={post}
                                />
                            </div>
                        ))) : (
                            range(count).map((index) => <CommentPlaceholder key={index} />)
                        )
                    }
                </ul>
                {canAdd ? (
                    inGroups ? (
                        <div>
                            <BlogPostCommentCreateForm
                                initialValues={initialValues}
                                isDesktop={!mobile}
                                isIOS={isIOS}
                                hasBlueToolbar={hasBlueToolbar}
                                onBlur={onBlur}
                                onFocus={onFocus}
                                onSave={onCreate}
                                requestUserPermissions={requestUserPermissions}
                                textareaRef={this.setTextareaRef}
                            />
                        </div>
                    ) : (
                        <div className={styles.CommentList__messageForm}>
                            <MessageForm
                                requestUser={requestUser}
                                requestUserPermissions={requestUserPermissions}
                                postKey={postKey}
                                initialValues={initialValues}
                                onSend={onCreate}
                                textareaRef={this.setTextareaRef}
                            />
                        </div>
                    )
                ) : showFakeTextareaIfCantAdd ? (
                    <div
                        className={styles.CommentList__fakeTextarea}
                        onClick={this.onAddCommentUnauthenticated}
                    >
                        <p className={styles.CommentList__fakeTextarea__label}>{BLOGS_ADD_NEW_COMMENT_PLACEHOLDER}</p>
                        <div className={styles.CommentList__fakeTextarea__footer}>
                            <div className={styles.CommentList__fakeTextarea__footer__fakeToolbar}>
                                <i className={cx('fa', 'fa-smile-o', styles.CommentList__fakeTextarea__footer__fakeToolbar__icon)} />
                                <i className={cx('fa', 'fa-camera', styles.CommentList__fakeTextarea__footer__fakeToolbar__icon)} />
                                <Img
                                    src={assetUrl + 'img/photoblog/stickers/0.png'}
                                    width={25}
                                    height={25}
                                />
                            </div>
                            <div className={styles.CommentList__fakeTextarea__footer__fakeBtn}>
                                <div className={styles.CommentList__fakeTextarea__footer__fakeBtn__label}>
                                    {SEND_COMMENT_FORUM}
                                </div>
                            </div>
                        </div>
                    </div>
                ) : null }
            </div>
        );
    }

    private onAddCommentUnauthenticated = () => {
        const { onAddCommentUnauthenticated, onStoreEvent, postId } = this.props;
        onStoreEvent('blog_fake_textarea_click', {
            post: postId,
        });
        if (onAddCommentUnauthenticated) {
            onAddCommentUnauthenticated();
        }
    };

    private onReply = (username) => {
        this.props.onReply(username);
        this.messageFormTextarea.focus();
    };

    private setTextareaRef = (r) => {
        this.messageFormTextarea = r;
        const { onSetTextareaRef } = this.props;
        if (onSetTextareaRef) {
            onSetTextareaRef(r);
        }
    };
}
